// @vue/component
import { useChallengeStore } from "@/stores/WheelAnalysis/challenge";
import { storeToRefs } from "pinia";

export default {
  name: "ChallengeStatement",

  setup() {
    const challengeStore = useChallengeStore();
    const { challengeType, challengeStatement, editMode } = storeToRefs(challengeStore);

    return { challengeStore, challengeType, challengeStatement, editMode };
  },

  mounted() {
    this.challengeStore.fetchWheelAnalysis();

    // Apply localized default *only if* the field is empty (or whitespace)
    this.applyLocalizedDefaultIfNeeded();
  },

  watch: {
    // If user switches languages, update the statement only if it still looks "default-y"
    "$i18n.locale"() {
      this.applyLocalizedDefaultIfNeeded({ allowReplaceExistingDefault: true });
    }
  },

  methods: {
    getLocalizedDefaultStatement() {
      return this.$t("wheelAnalysis.challenge.defaultStatement");
    },

    normalize(s) {
      return String(s || "").replace(/\r\n/g, "\n").trim();
    },

    // Heuristic: treat the stored value as "default" if it matches ANY known default shape.
    // This lets you migrate away from the old hardcoded English store default without clobbering real user edits.
    looksLikeOldEnglishDefault(s) {
      const txt = this.normalize(s);

      return (
          txt.startsWith("In _(") ||
          txt.includes("(Optional part 2)") ||
          txt.includes("we aim to improve quality of life sustainable development")
      );
    },

    applyLocalizedDefaultIfNeeded({ allowReplaceExistingDefault = false } = {}) {
      const current = this.challengeStatement;
      const currentNorm = this.normalize(current);
      const localizedDefault = this.getLocalizedDefaultStatement();

      const isEmpty = currentNorm.length === 0;
      const isOldEnglishDefault = this.looksLikeOldEnglishDefault(current);

      // If empty, always set the default.
      if (isEmpty) {
        this.challengeStatement = localizedDefault;
        // Don't call challengeStatementChanged() here; you probably only want to persist on blur.
        return;
      }

      // If locale changed, replace only if what we have appears to be an old/default template
      // (so we don't overwrite user edits).
      if (allowReplaceExistingDefault && isOldEnglishDefault) {
        this.challengeStatement = localizedDefault;
      }
    }
  }
};
